import { render, staticRenderFns } from "./VAdminDictionaryCard.vue?vue&type=template&id=117f151d"
import script from "./VAdminDictionaryCard.vue?vue&type=script&lang=js"
export * from "./VAdminDictionaryCard.vue?vue&type=script&lang=js"
import style0 from "./VAdminDictionaryCard.vue?vue&type=style&index=0&id=117f151d&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports